import { defaultConfig, createInput } from "@formkit/vue";
import { createMultiStepPlugin } from "@formkit/addons";
import { es } from "@formkit/i18n";
import "@formkit/addons/css/multistep";

// Custom inputs
import RatingInput from "@/components/Survey/inputs/RatingInput.vue";
import MatrixInput from "@/components/Survey/inputs/MatrixInput.vue";

const customInputs = {
	rating: createInput(RatingInput, {
		props: ["min", "max"],
	}),
	matrix: createInput(MatrixInput, {
		props: ["columns", "matrixRows"],
	}),
};

const config = defaultConfig({
	plugins: [createMultiStepPlugin()],
	locales: { es },
	locale: "es",
	inputs: customInputs,
	config: {
		classes: {
			// Global classes for all inputs
			global: {
				outer: "formkit-outer mb-4",
				wrapper: "formkit-wrapper",
				label: "formkit-label block text-sm font-medium text-slate-700 mb-1.5",
				inner: "formkit-inner",
				input: "formkit-input",
				help: "formkit-help text-xs text-slate-500 mt-1",
				messages: "formkit-messages list-none p-0 mt-1",
				message: "formkit-message text-red-500 text-sm",
			},
			// Text input
			text: {
				input: "w-full border-2 border-slate-200 rounded-lg px-4 py-3 text-base focus:border-primary-500 focus:outline-none transition-colors",
			},
			// Textarea
			textarea: {
				input: "w-full border-2 border-slate-200 rounded-lg px-4 py-3 text-base focus:border-primary-500 focus:outline-none transition-colors min-h-[120px] resize-y",
			},
			// Select
			select: {
				input: "w-full border-2 border-slate-200 rounded-lg px-4 py-3 text-base focus:border-primary-500 focus:outline-none transition-colors bg-white",
			},
			// Radio
			radio: {
				options: "formkit-options space-y-2",
				option: "formkit-option",
				wrapper: "flex items-center gap-3 p-3 border border-slate-200 rounded-lg cursor-pointer hover:border-primary-300 transition-colors",
				input: "formkit-radio-input w-5 h-5 text-primary-500 border-slate-300 focus:ring-primary-500",
				label: "formkit-option-label text-base text-slate-700 cursor-pointer mb-0",
			},
			// Checkbox
			checkbox: {
				options: "formkit-options space-y-2",
				option: "formkit-option",
				wrapper: "flex items-center gap-3 p-3 border border-slate-200 rounded-lg cursor-pointer hover:border-primary-300 transition-colors",
				input: "formkit-checkbox-input w-5 h-5 text-primary-500 border-slate-300 rounded focus:ring-primary-500",
				label: "formkit-option-label text-base text-slate-700 cursor-pointer mb-0",
			},
			// Submit button
			submit: {
				input: "w-full bg-gradient-to-r from-primary-500 to-primary-600 text-white font-semibold py-3 px-6 rounded-lg hover:from-primary-600 hover:to-primary-700 transition-all shadow-md hover:shadow-lg cursor-pointer",
			},
		},
	},
});

export default config;
